import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiModelReadyFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 51,
	viewBox: "0 0 50 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: 1,
			width: 49,
			height: 49,
			rx: 24.5,
			fill: "url(#paint0_linear_10958_14414)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: 1,
			width: 49,
			height: 49,
			rx: 24.5,
			stroke: "url(#paint1_linear_10958_14414)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 25,
			cy: 25.5,
			r: 9.75,
			fill: "white",
			fillOpacity: .9,
			stroke: "#75E0A7",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.3337 22.25L23.3753 28.2083L20.667 25.5",
			stroke: "#067647",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_10958_14414",
			x1: 25,
			y1: .5,
			x2: 25,
			y2: 50.5,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#DCFAE6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DCFAE6",
				stopOpacity: .2
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_10958_14414",
			x1: 25,
			y1: .5,
			x2: 25,
			y2: 50.5,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#ABEFC6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#ABEFC6",
				stopOpacity: 0
			})]
		})] })
	]
});
export default SvgAiModelReadyFilled;
